import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BasketQtyComponentDef } from '@df/basket/view/basket-qty.component.def';
import { App } from '@df/core/app';
import { AbService } from '@df/module-ab/ab.service';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { Subscription } from 'rxjs/internal/Subscription';
import { BasketDecorator } from '../customer/api/basket/basket.decorator';

export const ANIMATE_BASKET_AB_CONFIG = {
    showFor: 'B',
    experimentName: 'animateBasket'
};

@Component({
    selector: 'basket-qty',
    templateUrl: './basket-qty.html',
    styleUrl: './basket-qty.scss',
    host: {
        '(click)': 'handleClick()'
    },
    standalone: true,
    imports: [CommonModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketQtyComponent extends BasketQtyComponentDef {
    protected app = inject(App);
    protected abService = inject(AbService);

    protected abServiceSubscription?: Subscription;

    isAnimate = false;

    override get basket(): BasketDecorator {
        return <BasketDecorator>this.app.customer.basket;
    }

    override ngOnInit() {
        super.ngOnInit();

        this.abServiceSubscription?.unsubscribe();

        this.abServiceSubscription = this.abService.getSubject(ANIMATE_BASKET_AB_CONFIG.experimentName).subscribe(value => {
            if (value.variant === ANIMATE_BASKET_AB_CONFIG.showFor) {
                this.isAnimate = true;
            } else {
                this.isAnimate = false;
            }

            this.detectChanges();
        });
    }

    override ngOnDestroy() {
        super.ngOnDestroy();

        this.abServiceSubscription?.unsubscribe();
    }

    handleClick() {
        this.isAnimate = false;

        this.detectChanges();
    }
}
